<template>
    <section v-if="parseInt(this.$store.state.tip_tranzactie) == 1" class="containerg plata_card_response_section">
         <img src="@/assets/images/comanda_trimisa.svg"/>
         <div class="titlu_modal_checkout tilu_margin_zero">{{ $t('order_sent') }}</div>
         <div v-if="this.$store.state.durata_livrare_state != 0" class="mesaj_timp_livrare">{{ $t('mesaj_timp_livrare1') }} {{this.$store.state.durata_livrare_state}} {{ $t('mesaj_timp_livrare2') }}</div>
         <div v-else class="mesaj_timp_livrare">{{ $t('mesaj_timp_livrare3') }}</div>
    </section>
    <section v-else-if="parseInt(this.$store.state.tip_tranzactie) == 0" class="containerg plata_card_response_section erori_generale container404">
        <i class="ri-error-warning-fill"></i>   
        <div v-if="this.$store.state.eroare_generala_paid == ''" v-html="$t('eroare_tranz')">
        </div>
         <div v-else>        
            {{this.$store.state.eroare_generala_paid}}     
            <br/><br/>  
         </div>
         <a  class="btn_g_red" href="/">Acasa</a>
    </section>
    <section v-else class="containerg plata_card_response_section container404">
        <h1>Va rugam asteptati...</h1>
    </section>
</template>
<script>
  export default {
   
    mounted () {
        if (document.location.href.indexOf('paid?t=') === -1) {
            this.$router.push({ name: '404' })
        } 
    }, 
    beforeMount() {
    }
  }
</script> 
